import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { DialogAvatarGroupComponent } from './dialog-avatar-group.component';

export interface AvatarItem {
  picture: string;
  name: string;
  id?: number | string;
}

export interface AvatarGroupDialogData {
  items: AvatarItem[];
  itemsForLabel: string;
  itemLink: string;
}

@Component({
  selector: 'sbnb-avatar-group',
  templateUrl: './avatar-group.component.html',
  styleUrl: './avatar-group.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AvatarGroupComponent implements OnInit {
  @Input({ required: true }) items: AvatarItem[];
  /**
   * The maximum number of items to show in the tooltip
   */
  @Input() maxTooltipItems = 10;
  /**
   * If true, show the 'All' label instead of the individual items
   */
  @Input() allItems = false;
  @Input() itemsLabel = 'properties';
  @Input() allItemsLabel = 'All';
  /**
   * The label in the dialog header to tell you what the items are for (often a messaging rule)
   */
  @Input() itemsForLabel: string;
  /**
   * If true, show the 'All' label as well as the individually selected properties. In Direct we use 'Default' but want to show the individually selected properties too
   */
  @Input() expandAllItems = false;
  /**
   * A string representing the link to the item. Defaults to the property link bc this componentis usually used for properties
   */
  @Input() itemLink = '/properties/property/:id';

  constructor(private dialog: MatDialog) {}

  public tooltip = '';

  ngOnInit() {
    this.buildTooltip();
  }

  buildTooltip() {
    if ((this.allItems && !this.expandAllItems) || !this.items?.length) {
      return;
    }

    if (this.maxTooltipItems && this.items?.length > this.maxTooltipItems) {
      this.tooltip = `See more ${this.itemsLabel}`;
      return;
    }

    this.items.forEach((item) => {
      this.tooltip += `${item.name} \n`;
    });
  }

  openDialog() {
    const data: AvatarGroupDialogData = {
      items: this.items,
      itemsForLabel: this.itemsForLabel,
      itemLink: this.itemLink,
    };

    this.dialog.open(DialogAvatarGroupComponent, {
      width: '486px',
      maxHeight: '90vh',
      data,
    });
  }
}
